import container from '@/modules/core/ioc/Container';

export const HasContainerMixin = {
  beforeCreate() {
    this.$resolve = container.resolve.bind(container);
  }
};
